/**
 * TOS Guard Component
 *
 * Blocks access to protected routes if platform TOS requires re-acceptance.
 * Redirects user to TOS re-acceptance page until they accept the updated terms.
 *
 * @see PRP-4Q25-009 FR-3 for re-acceptance requirements
 */

import { PageSkeleton } from '@gw/ui';
import { Navigate, Outlet } from 'react-router-dom';

import { AppLayout } from '@/components/layouts/AppLayout';
import { usePlatformTOS } from '@/hooks/usePlatformTOS';

export function TOSGuard() {
  const { requiresReacceptance, isLoading } = usePlatformTOS();

  // Show loading while checking TOS status
  if (isLoading) {
    return (
      <AppLayout variant="default">
        <PageSkeleton />
      </AppLayout>
    );
  }

  // TOS requires re-acceptance - redirect to acceptance page
  if (requiresReacceptance) {
    return <Navigate to="/auth/accept-tos" replace />;
  }

  return <Outlet />;
}
